/** A small curated grid covers nearly every list people actually make. */
export const EMOJI_CHOICES = [
  '🛒',
  '🧳',
  '🎉',
  '📦',
  '🧽',
  '⛺',
  '🎁',
  '🏠',
  '🍽️',
  '🍕',
  '🍰',
  '☕',
  '🍺',
  '🥗',
  '🧺',
  '🧻',
  '👶',
  '🐶',
  '🌱',
  '🔧',
  '🎨',
  '📚',
  '🎬',
  '🎵',
  '✈️',
  '🚗',
  '🚲',
  '🏖️',
  '⛰️',
  '🎿',
  '🏊',
  '⚽',
  '💼',
  '💻',
  '📝',
  '📅',
  '💡',
  '🔑',
  '💊',
  '🩺',
  '❤️',
  '⭐',
  '✅',
  '🔥',
  '🌍',
  '🎓',
  '🛠️',
  '🧦',
]
